import axios from 'axios';

const updateOwnerOrAssignee = async ({
  serialNumber,
  ownerId,
  assigneeId,
  updateType,
  ownerType,
  assigneeType,
}: {
  serialNumber: string;
  ownerId?: string;
  assigneeId?: string;
  updateType: string;
  ownerType?: string;
  assigneeType?: string;
}) => {
  await axios.post('/supra/lockbox/update_owner_or_assignee', {
    serialNumber,
    ownerId,
    assigneeId,
    updateType,
    ownerType,
    assigneeType,
  });
};

export default updateOwnerOrAssignee;
